export default {
  defaultProps: {
    color: 'inherit',
    size: 45,
  },
};
